/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { ClonableMixin as o } from "../../core/Clonable.js";
import { JSONSupport as t } from "../../core/JSONSupport.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import { timeZoneProperty as s } from "../../time/timeZoneUtils.js";
let p = class extends o(t) {
  constructor(e) {
    super(e), this.creatorField = null, this.creationDateField = null, this.editorField = null, this.editDateField = null, this.realm = null, this.timeZone = null;
  }
};
e([r()], p.prototype, "creatorField", void 0), e([r()], p.prototype, "creationDateField", void 0), e([r()], p.prototype, "editorField", void 0), e([r()], p.prototype, "editDateField", void 0), e([r()], p.prototype, "realm", void 0), e([r(s("dateFieldsTimeReference", !0))], p.prototype, "timeZone", void 0), p = e([i("esri.layers.support.EditFieldsInfo")], p);
const l = p;
export { l as default };